import { gql } from '@apollo/client';

const SUPER_STICKY_TEMPLATES = gql`
  query SuperStickyTemplates($category: SuperStickyCategory!) {
    superStickyTemplates(category: $category) {
      label
      name
      stickyText
    }
  }
`;

export { SUPER_STICKY_TEMPLATES };
